module.exports = __webpack_public_path__ + "static/media/badge_village_trans.976aa80d.png";